import {
  Alert,
  Alignment,
  Button,
  Displaying,
  Primary,
  PRIMARY_COLOR,
  Spacing,
  Typography,
} from "@bonusx-global/bx-design-system";
import { ArrowUpRightOutlined, ChatQuestionSolid } from "@bonusx-global/bx-icons";
import styled from "@emotion/styled";
import Grid from "@mui/material/Grid";
import { SUGGEST_NEW_BONUSES_TEXT } from "../../../../../constants/commonStrings";
import type { NoResultsAlertProps } from "../interfaces/NoResultsAlertProps";

const additionalStyling = {
  bgcolor: Primary.light,
  ".MuiAlert-action": {
    alignItems: Alignment.center,
  },
};

const OneLineButton = styled(Button)`
  min-width: fit-content;
  max-height: fit-content;
`;

const DivContainer = styled.div`
  display: ${Displaying.flex};
  gap: ${Spacing[1500]};
`;

export function NoResultsAlertDesktop({ onClick }: Readonly<NoResultsAlertProps>): JSX.Element {
  return (
    <Alert icon={false} variant="standard" sx={additionalStyling} data-testid="no-search-result-alert-desktop">
      <DivContainer data-testid="no-search-result-alert-div-container">
        <Grid container alignItems={Alignment.center} justifyContent={Alignment.spaceBetween}>
          <Grid item gap={Spacing[750]} display={Displaying.flex} alignItems={Alignment.center}>
            <ChatQuestionSolid color={PRIMARY_COLOR} />
            <Typography variant="body2" color={Primary.dark} data-testid="no-search-result-alert-suggest-bonus-text">
              {SUGGEST_NEW_BONUSES_TEXT}
            </Typography>
          </Grid>
        </Grid>

        <OneLineButton
          size="small"
          color="primary"
          variant="outlined"
          endIcon={<ArrowUpRightOutlined />}
          onClick={onClick}
          data-testid="no-search-result-alert-button"
        >
          Suggerisci bonus
        </OneLineButton>
      </DivContainer>
    </Alert>
  );
}
